// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
    margin: 0;
}

@media print {
    body, html {
        width: 100% !important;
        height: 99% !important;
        margin: 0;

    }
    table {page-break-inside: avoid;}
}

.receipt {
    margin-top: 1px;
    width: 50mm;
    font-family: sans-serif;
    font-size: 8pt;
    font-stretch: condensed;
}
header h1 {
    font-size: 8pt;
    font-weight: bold;
}
h1{
    font-size: 8pt;
    font-weight: bold;
}
h2{
    font-weight: normal;
    font-size: 8pt;
}
header h2 {
    font-weight: normal;
    font-size: 8pt;

}
header h2:first-child {
    font-weight: bold;
}
section {
    width: 50mm;
    /*  overflow:hidden; */
    overflow-wrap: break-word;
}
.qr {
    width: 30mm;
}
.totals_per_vat {
    font-size: 7.5pt;
    border-collapse: collapse;
    width: 50mm;
}
.total_per_vat_text {
    text-align: center;
}
.totals_per_other_tax {
    font-size: 8pt;
    border-collapse: collapse;
    border-bottom: thin dashed black;
}
.totals_per_vat tbody {
    border-bottom: thin dashed black;
}
.total {
    font-weight: bolder;
}
.desc {
    width: 5mm;
    max-width: 5mm;
    text-overflow: "";
    overflow-wrap: break-word;
}
.tdtable{
    width: 5mm;
}
.cont_notation{
    max-width: 50mm;
}
`, "",{"version":3,"sources":["webpack://./src/Components/InvoicePrint/thermal-print.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;QACtB,SAAS;;IAEb;IACA,OAAO,wBAAwB,CAAC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;;AAElB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;AACnB","sourcesContent":["@page {\r\n    margin: 0;\r\n}\r\n\r\n@media print {\r\n    body, html {\r\n        width: 100% !important;\r\n        height: 99% !important;\r\n        margin: 0;\r\n\r\n    }\r\n    table {page-break-inside: avoid;}\r\n}\r\n\r\n.receipt {\r\n    margin-top: 1px;\r\n    width: 50mm;\r\n    font-family: sans-serif;\r\n    font-size: 8pt;\r\n    font-stretch: condensed;\r\n}\r\nheader h1 {\r\n    font-size: 8pt;\r\n    font-weight: bold;\r\n}\r\nh1{\r\n    font-size: 8pt;\r\n    font-weight: bold;\r\n}\r\nh2{\r\n    font-weight: normal;\r\n    font-size: 8pt;\r\n}\r\nheader h2 {\r\n    font-weight: normal;\r\n    font-size: 8pt;\r\n\r\n}\r\nheader h2:first-child {\r\n    font-weight: bold;\r\n}\r\nsection {\r\n    width: 50mm;\r\n    /*  overflow:hidden; */\r\n    overflow-wrap: break-word;\r\n}\r\n.qr {\r\n    width: 30mm;\r\n}\r\n.totals_per_vat {\r\n    font-size: 7.5pt;\r\n    border-collapse: collapse;\r\n    width: 50mm;\r\n}\r\n.total_per_vat_text {\r\n    text-align: center;\r\n}\r\n.totals_per_other_tax {\r\n    font-size: 8pt;\r\n    border-collapse: collapse;\r\n    border-bottom: thin dashed black;\r\n}\r\n.totals_per_vat tbody {\r\n    border-bottom: thin dashed black;\r\n}\r\n.total {\r\n    font-weight: bolder;\r\n}\r\n.desc {\r\n    width: 5mm;\r\n    max-width: 5mm;\r\n    text-overflow: \"\";\r\n    overflow-wrap: break-word;\r\n}\r\n.tdtable{\r\n    width: 5mm;\r\n}\r\n.cont_notation{\r\n    max-width: 50mm;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
